import type { SVGProps } from "react";
export interface GloveSmittenIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GloveSmittenIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GloveSmittenIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.125 21a2.125 2.125 0 0 1-2.126 2.125H6A2.125 2.125 0 0 1 3.875 21v-2.5a1.125 1.125 0 0 1 2.25 0v2.375h6.75V18.5a1.125 1.125 0 0 1 2.25 0z"
      />
      <path
        fill={color}
        d="M14.876 8.5a5.376 5.376 0 0 0-10.751 0v8c0 .483.392.875.875.875h10.25a.88.88 0 0 0 .576-.215l3.482-3.034.106-.1a1.65 1.65 0 0 0 .317-1.813l-.064-.129a1.65 1.65 0 0 0-2.306-.602l-.77.476A1.125 1.125 0 0 1 14.876 11zm2.25.648a3.895 3.895 0 0 1 3.908 6.438l-.248.236-3.482 3.034a3.13 3.13 0 0 1-2.053.769H5A3.125 3.125 0 0 1 1.875 16.5v-8a7.625 7.625 0 0 1 15.25 0v.648Z"
      />
    </svg>
  );
}
